
import { Button, Col, Select, Tabs } from "antd";
import DpdBucket from "./Component/DpdBucket";
import FirstvsRepeat from "./Component/FirstvsRepeat";
import GenderAnalytics from "./Component/GenderAnalysis";
import PricipalPaid from "./Component/PrincipalPaid";
import QuartileBucket from "./Component/Quartile";
import { useState } from "react";
import { fetchAnalysisDaily } from "../../../services/adminController";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";


const DailyIntervention = () => {
  const data = useParams();
  const clientId = data?.lenderId
  const [stage] = useState("STAGE_2");
  const [date] = useState("11/12/2025");
  const today = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(today);

  const [status, setStatus] = useState("ALL");

  const formatToDDMMYYYY = (dateStr: any) => {
    if (!dateStr) return "";
    const [yyyy, mm, dd] = dateStr.split("-");
    return `${dd}/${mm}/${yyyy}`;
  };

  const handleCancelSearch = () => {
    setSelectedDate(today);
    refetchAnalysis();
  };


  const { data: analysisData, isLoading, refetch: refetchAnalysis } = useQuery({
    queryKey: ["analysisData", { clientId, date: formatToDDMMYYYY(selectedDate), stage, status }],
    queryFn: fetchAnalysisDaily,
  });

  const items = [
    {
      label: "DPD Bucket",
      key: "1",
      children: <DpdBucket data={analysisData?.DPD} />,
    },
    {
      label: "Principal Paid",
      key: "2",
      children: <PricipalPaid
        data={
          [...(analysisData?.PRINCIPAL_PAID || [])].sort((a, b) => {
            const startA = parseInt(a.bucket.split(/[–-]/)[0]);
            const startB = parseInt(b.bucket.split(/[–-]/)[0]);
            return startA - startB;
          })
        }

      />,
    },
    {
      label: "Gender Analysis",
      key: "3",
      children: <GenderAnalytics

        data={[...(analysisData?.GENDER || [])].reverse()}

      />,
    },
    {
      label: "First Vs Repeat",
      key: "4",
      children: <FirstvsRepeat data={analysisData?.BORROWER_TYPE} />,
    },
    {
      label: "Quartile Buckets",
      key: "5",
      children: <QuartileBucket data={analysisData?.QUARTILE} />,
    },
  ];

  return (
    <div className="mt-1 ">
      <div className="flex justify-between">
        <div>
          <strong>Selected Date:</strong> {formatToDDMMYYYY(selectedDate)}
        </div>
        <div className="w-50 flex">
          <input
            type="date"
            value={formatToDDMMYYYY(selectedDate)}
            onChange={(e) => setSelectedDate(e.target.value)}
            style={{
              border: "1px solid #6f56a3",
              padding: "5px",
              borderRadius: "2px",
            }}
          />
          <Col className=" pr-3">
            <Button
              type="primary"
              block
              className="pl-1 ml-4 pr-1"
              onClick={handleCancelSearch}
            >
              Clear
            </Button>
          </Col>
        </div>
      </div>
      <Tabs items={items}></Tabs>
    </div>
  );
};

export default DailyIntervention;